<div class="outer">
  <app-header></app-header>
  <div class="content" tabindex="-1" appAutoScrollToTop>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
